export default "/images/6acd6b57b23a37592e6f56876db1895a.png";